import { addDays, endOfDay, startOfDay } from 'date-fns';

import { range } from './range';

import type { IsoDate } from '@insify/global-date';

const nextYear = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date;
};

const getLocaledMonthName = (monthNum: number, locale: string, mode: 'long' | 'short'): string => {
  const date = new Date(new Date().getFullYear(), monthNum - 1, 1);
  return date.toLocaleDateString(locale, { month: mode });
};

const getLocaledMonthNames = (locale = 'de', mode: 'long' | 'short' = 'long'): string[] => {
  return range(1, 12, 1).map((num: number) => getLocaledMonthName(num, locale, mode));
};

const formatDateToISO = (date: Date): IsoDate =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
    2,
    '0',
  )}` as IsoDate;

const getDateBoundaries = (dateBoundariesInDays: [number, number]) => {
  return [
    startOfDay(addDays(new Date(), dateBoundariesInDays[0])),
    endOfDay(addDays(new Date(), dateBoundariesInDays[1])),
  ];
};

const isDateWithinBoundaries = (value: string, dateBoundariesInDays: [number, number]) => {
  const [startDate, endDate] = getDateBoundaries(dateBoundariesInDays);
  const date = new Date(value);
  return date >= startDate && date <= endDate;
};

export { nextYear, getLocaledMonthNames, formatDateToISO, getDateBoundaries, isDateWithinBoundaries };
